<template>
    <el-row>
        <el-col :span="9" class="pl15">
            <el-row>
                <el-col>
                    <key-info />
                </el-col>
            </el-row>
            <el-row class="card-deal-params">
                <el-col :span="6">
                    <ul class="deal-params-menu">
                        <li
                            v-for="card in paramCards"
                            :key="card.component"
                            :class="{ active: currentParamCard === card.component }"
                            @click="currentParamCard = card.component"
                        >
                            <span>
                                {{ card.title }}
                            </span>
                        </li>
                    </ul>
                </el-col>
                <el-col :span="18">
                    <keep-alive>
                        <component :is="currentParamCard" />
                    </keep-alive>

                    <div class="actions-wrapper">
                        <template v-if="editMode">
                            <el-button class="action-save" type="warning" size="medium" @click="save" v-if="canEdit">
                                {{ saveBtnText }}
                            </el-button>
                            <el-button class="action-close" type="default" size="medium" @click="close">
                                Отменить
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button class="action-edit" type="warning" size="medium" @click="edit" v-if="canEdit">
                                Редактировать
                            </el-button>
                            <el-button class="action-close" type="default" size="medium" @click="close">
                                Закрыть
                            </el-button>
                        </template>
                    </div>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="15" :class="['mt-32','ml15', { 'darken-deal-column': isDarkenColumn }]" style="width: 61%;">
            <tasks
                :entity-id="this.deal.id"
                entity-type="deal"
                @changeVisibility="darkenColumn"
            />
            <events
                entity-type="deal"
                :entity-id="this.deal.id"
                :entity="deal"
                @changeVisibility="darkenColumn"
                v-if="this.deal.id"
            />
        </el-col>
    </el-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faCheckSquare, faEye, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import '@/assets/styles/card-complex.scss';
import '@/assets/styles/card.scss';
import KeyInfo from '@/views/crm/deals/card-blocks/KeyInfo';
import Measurement from '@/views/crm/deals/card-blocks/Measurement';
import Production from '@/views/crm/deals/card-blocks/Production';
import Contract from '@/views/crm/deals/card-blocks/Contract';
import Installation from '@/views/crm/deals/card-blocks/Installation';
import Complaint from '@/views/crm/deals/card-blocks/Complaint';
import Contact from '@/views/crm/deals/card-blocks/Contact';
import Tasks from '@/components/Tasks';
import Events from '@/components/events/Events';
import { eventBus } from '@/common/eventBus';

library.add(faCheck, faCheckSquare, faSquare, faEye, faPaperclip);

export default {
    name: 'MainInfo',
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            isDarkenColumn: false,
            currentParamCard: 'contact',
            paramCards: [
                { component: 'contact', title: 'Контакт' },
                { component: 'measurement', title: 'Замер' },
                { component: 'contract', title: 'Договор' },
                { component: 'production', title: 'Производство' },
                { component: 'installation', title: 'Монтаж' },
                { component: 'complaint', title: 'Рекламация' }
            ],
            statusParamsCardTable: [
                'contact', //Контакт установлен –> Контакт
                'measurement', //Замер назначен -> Замер
                'measurement', //Замер был, следить -> Замер
                'contract', //Договор -> Договор
                'contract', //Доставка -> Договор
                'installation', //Монтаж назначен -> Монтаж
                'installation', //Монтаж выполнен -> Монтаж
                'contract', //Успешно завершено -> Договор
                'complaint', //Рекламация Открыта -> Рекламация
                'complaint', //Рекламация Закрыта -> Рекламация
                'contract', //Договор Фиксация -> Договор
                'contact', //Отложенный спрос -> Контакт
                'contact', //Закрыто и не реализовано -> Контакт
                'contact', //Отказ от замера -> Контакт
                'measurement' //Тех отказ -> Замер
            ]
        };
    },
    components: {
        Contract,
        KeyInfo,
        Measurement,
        Production,
        Installation,
        Complaint,
        Contact,
        Tasks,
        Events
    },
    computed: {
        deal() {
            return this.$store.state.deals.current;
        },
        status_id() {
            return this.$store.state.deals.current.status_id;
        },
        approvedRoles() {
            return this.$store.getters['references/rolesBySectionDeal'];
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => this.approvedRoles.includes(x));
            return intersection.length > 0;
        },
        editMode() {
            return this.$route.meta.editMode || false;
        },
        saveBtnText() {
            return this.dealId === 0 ? ' Создать ' : 'Сохранить';
        },
        isNew() {
            return +this.dealId === 0;
        }
    },
    methods: {
        darkenColumn(value) {
            this.isDarkenColumn = value;
        },
        async editCard(id) {
            try {
                await this.$store.dispatch('deals/getDeal', id);
                this.$router.push({ name: 'deal-card', params: { id: '' + this.id } });
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.$router.push({ name: 'deals' });
            }
        },
        edit() {
            if (this.canEdit) {
                this.loading = true;
                this.editCard(this.id);
            }
        },
        save() {
            this.loading = true;
            const action = this.isNew ? 'createDeal' : 'updateDeal';
            this.$store.dispatch('deals/' + action)
                .then(() => {
                    this.$store.dispatch('references/loadReferenceByName', 'tags');
                    if (this.$store.state.deals.current.id) {
                        eventBus.$emit('tasks-need-update', { entityType: 'deal', entityId: this.$store.state.deals.current.id });
                        eventBus.$emit('status-updated', this.$store.state.deals.current.status_id);
                        this.$message({
                            showClose: true,
                            message: 'Карточка сделки успешно сохранена',
                            type: 'success',
                            duration: 5000,
                            customClass: this.alertClass()
                        });
                        this.$router.push({ name: 'deal-card', params: { id: '' + this.$store.state.deals.current.id } });
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                })
                .finally(() => { this.loading = false; });
        },
        close() {
            this.$router.go(-1);
        }
    },
    watch: {
        status_id(newValue) {
            if (newValue) {
                this.currentParamCard = this.statusParamsCardTable[newValue - 1];
            }
        }
    }
};
</script>
